import {
  VoucherJoinInfoDto,
  VoucherJoinInfoCreateDto,
  VoucherJoinInfoUpdateDto,
} from 'src/types/generated';

import BaseCrudApiModule from 'src/api/baseCrud';

class VoucherApi extends BaseCrudApiModule<VoucherJoinInfoDto, VoucherJoinInfoCreateDto, VoucherJoinInfoUpdateDto> {
  protected baseRoute = '/vouchers';

  /**
   * Get voucher translations by voucher ID
   */
  public getTranslations(id: number) {
    return this._get<any[]>(`${this.baseRoute}/${id}/translations`);
  }

  /**
   * Create new voucher translation
   */
  public createTranslation(translationData: any) {
    return this._post<any>(`${this.baseRoute}/${translationData.voucherId}/translations`, translationData);
  }

  /**
   * Update specific voucher translation
   */
  public updateTranslation(translationId: number, translationData: any) {
    return this._patch<any>(`${this.baseRoute}/translations/${translationId}`, translationData);
  }

  /**
   * Get voucher by ID (alias for get method)
   */
  public getById(id: string | number) {
    return this.get(id);
  }

  /**
   * Set/update voucher translations (bulk operation)
   */
  public setTranslations(voucherId: number, translations: any[]) {
    return this._post<any[]>(`${this.baseRoute}/${voucherId}/translations`, translations);
  }

  /**
   * Delete specific voucher translation by language
   */
  public deleteTranslation(voucherId: number, languageId: number) {
    return this._delete(`${this.baseRoute}/${voucherId}/translations/${languageId}`);
  }

  /**
   * Get voucher usage analytics and history
   */
  public getAnalytics(voucherId: number) {
    return this._get<any[]>(`${this.baseRoute}/${voucherId}/analytics`);
  }

  /**
   * Get voucher usage history
   */
  public getUsages(voucherId: number) {
    return this._get<any[]>(`${this.baseRoute}/${voucherId}/usages`);
  }

  /**
   * Generate unique voucher code
   */
  public generateCode() {
    return this._get<{ code: string }>(`${this.baseRoute}/generate-code`);
  }

  /**
   * Validate voucher code (for testing purposes)
   */
  public validateCode(code: string, salePointId: number, cartItems: any[], cartTotal: number) {
    return this._post('vouchers/validate', {
      code,
      salePointId,
      cartItems,
      cartTotal,
    }, { baseURL: this.instance.defaults.baseURL?.replace('/api/private', '/api/public') });
  }
}

export default VoucherApi;
